import React, { useState, useEffect, useRef } from "react";
import { Grid, Typography, Card, CardMedia, CardContent, IconButton, Box } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import ProductosCarruselLargo from "./ProductosCarruselLargo";
import { ImagenesGlobal } from "../global/ImagenesGlobal";

export const ProductoXcategorias = ({
	allCategory = {},
	openModal,
	discountPercentage = 0,
	default_img,
	loadImageS,
	convertPrice = (() => { })
}) => {
	const API_url = process.env.REACT_APP_API_URL;

	const listCategory = Object.keys(allCategory);

	const [categoryView, setCategoryView] = useState({
		name: null,
		list: []
	});

	function viewSelected(nameCategory, listSelected, decision = true) {
		const newValue = {
			name: decision ? nameCategory : null,
			list: decision ? listSelected : null,
		};

		setCategoryView(newValue);
	}

	return (
		<div style={{ margin: '1rem 0rem', display: 'flex', flexDirection: 'column', gap: '15px' }}>
			{
				categoryView.name == null && categoryView.list.length == 0 && listCategory.map((names) => (
					<div style={{ position: 'relative' }}>
						<ProductosCarruselLargo
							productos={allCategory[names]}
							showTitle={names}
							allProducts={allCategory[names]}
							discountPercentage={discountPercentage}
							sizeCardName='--card-size-diferent'
							loadImageS={loadImageS}
						/>
						<button style={{ cursor: 'pointer', position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, backgroundColor: "transparent", border: 'none', padding: '0px' }} onClick={() => { viewSelected(names, allCategory[names]) }}>
						</button>
					</div>
				))
			}

			{
				categoryView.name != null && categoryView.list.length > 0 && (
					<div style={{ width: '100%', backgroundColor: '#fff', padding: '15px' }}>
						<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
							<button className="btn-back" onClick={() => setCategoryView({ name: null, list: [] })}>
								<ArrowBackIos sx={{ fontSize: '16px' }} />
								<span>Atras</span>
							</button>

							<h2 style={{ fontWeight: 700, fontSize: '25px' }}>{categoryView.name}</h2>
							<span> </span>
						</div>

						<div className="all-products">
							{
								categoryView.list.map((objs, index) => (
									<Card
										key={index}
										style={{
											cursor: "pointer",
											boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
											transition: "transform 0.2s ease, box-shadow 0.2s ease",
											paddingBottom: "0px",
										}}
										onClick={() => openModal(objs)}
										className="shadow-lvl6"
									>
										<ImagenesGlobal url={objs?.img_list[0] ?? null} style={{ objectFit: 'cover', width: '100%' }} alt={objs.product_name} loadImageS={loadImageS} />

										<CardContent
											sx={{
												"p": 0,
												"&:last-child": { paddingBottom: 0 },
												"boxShadow": "none",
											}}
											style={{
												padding: "8px",
												display: "flex",
												alignItems: "flex-start",
												justifyContent: "space-between",
												gap: "8px",
											}}>
											<Typography
												variant="body2"
												style={{
													fontWeight: "bold",
													fontSize: "0.8rem",
													textAlign: "left",
													display: "-webkit-box",
													WebkitLineClamp: 2,
													WebkitBoxOrient: "vertical",
													overflow: "hidden",
													textOverflow: "ellipsis",
													lineHeight: "1.2em",
													maxHeight: "2.4em",
													flex: 1,
												}}
												title={objs.product_name}>
												{objs.product_name}
											</Typography>

											{discountPercentage > 0 ? (
												<div
													style={{
														textAlign: "right",
														display: "flex",
														flexDirection: "column",
													}}>
													<Typography
														variant="caption"
														sx={{
															fontSize: "0.7rem",
															textDecoration: "line-through",
															color: "#999",
														}}>
														{convertPrice(objs.sale_price, objs?.currency)}
													</Typography>
													<Typography
														variant="caption"
														color="green"
														sx={{
															fontSize: "0.75rem",
															fontWeight: 600,
														}}>
														{convertPrice(
															parseFloat(objs.sale_price) *
															(1 - discountPercentage / 100)
															, objs?.currency)}
													</Typography>
												</div>
											) : (
												<Typography
													variant="caption"
													color="green"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														whiteSpace: "nowrap",
														alignSelf: "flex-start",
													}}>
													{convertPrice(objs.sale_price, objs?.currency)}
												</Typography>
											)}
										</CardContent>
									</Card>
								))
							}
						</div>
					</div>
				)
			}

		</div>
	);
};